export default __webpack_public_path__ + "6f0618452b43f520da2842caffa01e1e.svg";